import { useCallback, useMemo } from 'react';

import { useAtomValue } from 'jotai';
import { atomUserValues, type ExperimentalGroup } from './jotai/user.atom';

export const useCheckUserExperimentGroup = (params: {
  sno: `EXP${number}`;
  targetGroups: ExperimentalGroup[];
}) => {
  const value = useAtomValue(atomUserValues);

  return useCallback(() => {
    const targetExpGroup = value?.experimentalGroups[params.sno];

    const currentGroup = targetExpGroup ?? 'else';
    return params.targetGroups.includes(currentGroup);
  }, [params.sno, params.targetGroups, value]);
};

/**
 * - 실험그룹 값을 반환합니다.
 * @example
const value = useExperimentGroupValue('EXP123');
});
 */
export const useExperimentGroupValue = (params: {
  sno: `EXP${number}`;
}): ExperimentalGroup => {
  const value = useAtomValue(atomUserValues);
  return value?.experimentalGroups[params.sno] ?? 'else';
};

/**
 * - 실험그룹에 해당하는지 확인할 수 있는 훅
 * - targetGroups에 'else'를 넣으면 실험이 종료되어도 true를 반환합니다.
 * 
 * @example
const isExperimental = useExperimentGroup({
  sno: 'EXP123',
  targetGroups: ['A', 'else'],
});
 */
export const useExperimentGroup = (params: {
  sno: `EXP${number}`;
  targetGroups: ExperimentalGroup[];
}): boolean => {
  const checkUserExperimentGroup = useCheckUserExperimentGroup(params);

  return useMemo<boolean>(() => {
    return checkUserExperimentGroup();
  }, [checkUserExperimentGroup]);
};
